module.exports = __webpack_public_path__ + "static/media/otp-code.a2b5e49a.png";